import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicRockMould from "../Components/ProjPicRockMould";

const ProjectPageRockMould = () => {
    return (
        <>
            <Navbar />
            <ProjPicRockMould />
            <Footer />
        </>
    );
};

export default ProjectPageRockMould;
